module.exports = __webpack_public_path__ + "static/media/logo_icon_white.e6627acd.svg";